import React, { useState } from 'react'

const AuthContext = React.createContext(null)

export const AuthProvider = ({ user, children }) => {    
    const [currentUser, setCurrentUser] = useState(user)

    //console.log("CURRENT USER ", currentUser)

    return (
        <AuthContext.Provider value={{ currentUser, setCurrentUser }}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuthContext = () => React.useContext(AuthContext) 